export default class MergeFieldOptionCtrl {
  onOptionSelected(option) {
    this.selectedValue = option;
    this.selectedValueDisplay = this.formatOptionDisplay({ option });
    if (this.onSelect) {
      this.onSelect({ option });
    }
  }
}
